'use client';

import AppImageLink from 'components/imagelink';
import { BLOG_ROUTING_BASE } from 'config';
import Link from 'next/link';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Image from 'next/image';
import { prepareImagePath } from 'services/lib/util';
import { PublicationDate } from '../../publication-date/publication-date';
import { Categories } from '../../categories/categories';

const ACFTeasersSlider = ({ articles }) => {
  if (!articles || articles.length === 0) return null;

  return (
    <div className="teasersWrapper w-full px-0">
      <Swiper
        modules={[Navigation]}
        slidesPerView={'auto'}
        spaceBetween={16}
        freeMode={true}
        pagination={{ clickable: true }}
      >
        {articles.map((item) => {
          const teaser = item.node ? item.node : item;
          const imageNode = teaser?.featuredImage?.node;

          return (
            <SwiperSlide className="teaser px-0" key={teaser.id}>
              <div className="image w-full px-0">
                {imageNode?.sourceUrl && (
                  <AppImageLink href={`${BLOG_ROUTING_BASE}${teaser.uri}`}>
                    <Image
                      src={prepareImagePath(imageNode.sourceUrl)}
                      alt={imageNode.altText || teaser.title.substring(0, 40) || ''}
                      title={imageNode.title}
                      width={283}
                      height={160}
                      sizes="(max-width: 768px) 85vw, (max-width: 1240px) 50vw, 25vw"
                      className="h-auto w-full object-cover px-0"
                    />
                  </AppImageLink>
                )}
              </div>

              <div className="content w-full px-0">
                <p className="title m-0 line-clamp-2 px-0 text-[1rem] font-normal leading-[1.5] text-white">
                  <Link href={`${BLOG_ROUTING_BASE}${teaser.uri}`} className="px-0 no-underline hover:underline">
                    {teaser.title}
                  </Link>
                </p>

                <div className="teaserDate flex flex-wrap items-center px-0">
                  <PublicationDate date={teaser.date} />
                  {teaser.categories != null && <Categories categories={teaser.categories} />}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ACFTeasersSlider;
